import { render, staticRenderFns } from "./BudgetSpendBreakdown.vue?vue&type=template&id=d672fb6e&scoped=true"
import script from "./BudgetSpendBreakdown.vue?vue&type=script&lang=js"
export * from "./BudgetSpendBreakdown.vue?vue&type=script&lang=js"
import style0 from "./BudgetSpendBreakdown.vue?vue&type=style&index=0&id=d672fb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d672fb6e",
  null
  
)

export default component.exports